import { render, staticRenderFns } from "./main-professional.vue?vue&type=template&id=e1f622d0&scoped=true&"
import script from "./main-professional.vue?vue&type=script&lang=js&"
export * from "./main-professional.vue?vue&type=script&lang=js&"
import style0 from "./main-professional.vue?vue&type=style&index=0&id=e1f622d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f622d0",
  null
  
)

export default component.exports